import { FormEvent, useEffect, useMemo, useState } from "react";
import * as CommonTypes from '../../../types/common.types'
import styled from "styled-components";
import { useGlobal } from "../../../context/global";
import ToursService from "../../../services/tours.service";
import { useAlly } from "../../../context/ally";
import AllyService from "../../../services/ally.service";
import m from "../../../styles/molanturTheme";
import { Button, Card, Icon, Label, Notice, Segmented, WizardShell, clp, longDate, tourVisual } from "../ui";
import repartir from "../../../utils/repartir";
import useEntradas from "../useEntradas";

// Paso 3: revisar y enviar. Acá se crean las reservas (una por huésped), con el precio de la ficha
// del aliado. Si las entradas van incluidas, su monto se calcula solo con las tarifas de cada parque
// (edad y nacionalidad de cada huésped); un tour que no entra a ningún parque no las ofrece.
export default function TicketPaymentGroup() {
    const { setMessage, setIsLoading } = useGlobal()
    const { newGroup, setNewGroupReservations, setSummary, setIsConfirmBoucherModalOpen, 
        setIsTicketPaymentGroupModalOpen, newGroupReservationData, setNewGroupReservationData, user, isCreateGroupModalOpen } = useAlly()
    const [tour, setTour] = useState<CommonTypes.TourInfo>()
    const [me, setMe] = useState<CommonTypes.Ally>()

    useEffect(() => {
        async function fetchTours() {
            console.log(newGroupReservationData?.tour_id, user?.user.agency_id)
            try {
                const response = await ToursService.getDetailTourInfo(newGroupReservationData?.tour_id || '', user?.user.agency_id || '')
                setTour(response.data)
                const responseMe = await AllyService.me()
                setMe(responseMe.data)
            } catch (error) {
                console.error('Error fetching tours:', error)
            }
        }
        fetchTours()
    }, [newGroupReservationData?.tour_id, user?.user.agency_id])

    const price = useMemo(() => {
        if (!me || !newGroupReservationData) return 0
        const price = me?.tour_prices?.find(tp => tp.tour_id === newGroupReservationData?.tour_id)?.price || 0
        return price
    }, [me, newGroupReservationData])

    // Tour privado (por vehículo): el precio del aliado es por el vehículo completo y la agencia lo
    // reparte entre los huéspedes del grupo, no se cobra entero a cada uno.
    const privado = tour?.unidad_precio === 'por_vehiculo'
    const partes = privado ? repartir(price, newGroup.length) : []

    const { cotizacion, cargando } = useEntradas(newGroupReservationData?.tour_id, newGroupReservationData?.reservation_date, newGroup.map(p => p.id || ""))
    const sinParques = !!cotizacion?.sin_parques
    const incluidas = newGroupReservationData?.ticket_included === true && !sinParques
    const entradas = incluidas ? (cotizacion?.total || 0) : 0
    // Quien el parque no autoriza bloquea siempre (no puede hacer el tour); los demás problemas del
    // cálculo solo importan si las entradas van incluidas.
    const noAutorizados = (cotizacion?.pasajeros || []).filter(p => p.prohibido).map(p => p.error as string)
    const erroresEntradas = noAutorizados.length ? noAutorizados : incluidas ? (cotizacion?.errores || []) : []

    async function onSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        console.log(newGroup);
        console.log(newGroupReservationData);
        console.log(tour);
        // Antes estos casos cortaban con un return mudo: el botón no hacía nada y el aliado no sabía
        // por qué (le pasó a un aliado real con un tour sin precio configurado en su ficha).
        if (!price) {
            setMessage({
                type: 'error',
                content: 'Este tour no tiene un precio asignado para ti. Contacta a la agencia para que lo configure.'
            })
            setTimeout(() => setMessage(undefined), 8000)
            return
        }
        if (!newGroupReservationData || (!sinParques && newGroupReservationData.ticket_included === undefined)) {
            setMessage({ type: 'error', content: 'Indica si las entradas van incluidas o si los huéspedes las pagan en el parque.' })
            setTimeout(() => setMessage(undefined), 5000)
            return
        }
        if (erroresEntradas.length) {
            setMessage({ type: 'error', content: erroresEntradas[0] })
            setTimeout(() => setMessage(undefined), 8000)
            return
        }
        if (!newGroup.length) return
        setIsLoading(true)
        try {
            for (let i = 0; i < newGroup.length; i++) {
                const passenger = newGroup[i];
                const submittingData = {
                    passenger_id: passenger.id,
                    price: price,
                    tickets: 0,
                    payment_methods: [{ name: 'Deuda', value: price }],
                    tour_id: newGroupReservationData.tour_id,
                    reservation_date: newGroupReservationData.reservation_date,
                    // Sin parques no hay entradas: ni incluidas ni a pagar en el parque.
                    ticket_included: sinParques ? null : newGroupReservationData.ticket_included,
                    group_id: newGroupReservationData.group_id,
                } as unknown as CommonTypes.SubmitReservation
                const response = await (await AllyService.createReservation(submittingData)).data
                // En un privado la respuesta de los primeros trae una parte más grande (se repartía entre menos).
                const parte = privado ? partes[i] : price
                setSummary(prev => ([...prev, {...response, reservation: {...response.reservation, price: parte}}]))
                setMessage({
                    type: 'success',
                    content: 'Reserva enviada a Molantur'
                })
                console.log(response)
                setNewGroupReservations(prev => [...prev, {
                    id: response.reservation.id,
                    price: parte,
                    // El monto de entradas lo calculó el backend al guardar.
                    tickets: Number(response.reservation.tickets || 0),
                    ticket_included: response.reservation.ticket_included,
                    tour_id: newGroupReservationData.tour_id,
                    reservation_date: newGroupReservationData.reservation_date,
                    payment_methods: [{ name: 'Deuda', value: parte }],
                } as CommonTypes.Reservation])
            }
            setIsConfirmBoucherModalOpen(true)
        } catch (error: any) {
            // El backend manda un texto claro para errores conocidos (ej. pasajero que ya tiene ese
            // tour esa fecha, precio distinto al configurado) — mostrarlo en vez del genérico.
            const serverMessage = error?.response?.status < 500 && typeof error?.response?.data === 'string'
                ? error.response.data
                : undefined
            setMessage({
                type: 'error',
                content: serverMessage || 'Ocurrió un error, por favor intenta de nuevo'
            })
        }
        finally {
            setIsLoading(false)
            setTimeout(() => setMessage(undefined), 5000)
        }
        console.log(newGroupReservationData)
        
    }
    const date = newGroupReservationData?.reservation_date ? new Date(newGroupReservationData.reservation_date) : undefined
    const tourId = newGroupReservationData?.tour_id || ''
    const { tone, picto } = tourVisual(tourId)
    const totalTours = privado ? price : price * newGroup.length
    const total = totalTours + entradas

    return (
        <WizardShell
            step={3}
            title="Revisar y enviar"
            flow={isCreateGroupModalOpen ? 'Agregar huéspedes' : 'Agregar tour'}
            onClose={() => setIsTicketPaymentGroupModalOpen(false)}
            closeIcon="chevronLeft"
            closeLabel="Volver"
            onSubmit={onSubmit}
            footer={<Button type="submit" full size="lg" icon="check">Enviar a Molantur</Button>}
        >
            <Step>
                <Card $pad={0} className="review">
                    <div className="band" style={{ background: `linear-gradient(135deg, ${tone[0]}, ${tone[1]})` }}>
                        <img src={picto} alt="" />
                        <div>
                            <div className="band-tour">{tourId}</div>
                            <div className="band-date">{date ? longDate(date) : ''}</div>
                        </div>
                    </div>
                    <dl>
                        <div>
                            <dt>Huéspedes</dt>
                            <dd>{newGroup.map(p => p.name).filter(Boolean).join(', ')}</dd>
                        </div>
                        <div>
                            <dt>{privado ? 'Precio del privado (vehículo)' : 'Precio por huésped'}</dt>
                            <dd>{price ? clp(price) : 'Sin precio configurado'}</dd>
                        </div>
                    </dl>
                </Card>

                <Label className="section">Entradas al parque</Label>
                {sinParques ? (
                    <Notice $tone="info">
                        <Icon name="info" size={16} />
                        <span>Este tour no tiene entradas a parques.</span>
                    </Notice>
                ) : (
                    <Segmented
                        label="Entradas al parque"
                        variant="choice"
                        options={[{ value: true, label: 'Entradas incluidas' }, { value: false, label: 'Pagan en el parque' }]}
                        value={newGroupReservationData?.ticket_included}
                        onChange={included => setNewGroupReservationData(prev => ({...prev, ticket_included: included}))}
                    />
                )}

                {erroresEntradas.length > 0 && (
                    <Notice $tone="warn" role="alert" style={{ marginTop: 10 }}>
                        <Icon name="info" size={16} />
                        <span>{erroresEntradas.join(' ')}</span>
                    </Notice>
                )}

                {incluidas && !erroresEntradas.length && cotizacion && (
                    <dl className="entradas">
                        {cotizacion.pasajeros.map(p => (
                            <div key={p.passenger_id}>
                                <dt>{p.name}{p.edad !== null ? ` · ${p.edad} años` : ''}</dt>
                                <dd>{p.monto ? clp(p.monto) : 'Gratis'}</dd>
                            </div>
                        ))}
                    </dl>
                )}

                <div className="total">
                    <div>
                        <span className="total-label">Total para Molantur</span>
                        <span className="total-calc">
                            {privado ? `Privado para ${newGroup.length} huéspedes · ~${clp(partes[0] || 0)} c/u` : `${newGroup.length} × ${clp(price)}`}
                            {incluidas && !erroresEntradas.length ? ` + entradas ${cargando ? '…' : clp(entradas)}` : ''}
                        </span>
                    </div>
                    <strong>{clp(total)}</strong>
                </div>
                {!sinParques && (
                    <p className="note">
                        <Icon name="info" size={15} stroke={2} />
                        <span>{incluidas
                            ? 'Las entradas se calculan con la tarifa de cada parque según la edad y nacionalidad de cada huésped.'
                            : 'Si eliges "Pagan en el parque", cada huésped paga su entrada directamente en el parque.'}</span>
                    </p>
                )}
            </Step>
        </WizardShell>
    )
}

const Step = styled.div`
    .review {
        overflow: hidden;
        margin-bottom: 4px;
    }
    .band {
        position: relative;
        height: 120px;
        overflow: hidden;
        display: flex;
        align-items: flex-end;
        padding: 12px 14px;
        color: #fff;
        &::after {
            content: '';
            position: absolute;
            inset: 0;
            background: linear-gradient(180deg, transparent 30%, rgba(0,0,0,0.34) 100%);
        }
        img {
            position: absolute;
            right: -6px;
            bottom: -8px;
            height: 78%;
            opacity: 0.32;
        }
        > div {
            position: relative;
            z-index: 1;
        }
    }
    .band-tour {
        font-family: ${m.font.display};
        font-weight: 600;
        font-size: 22px;
    }
    .band-date {
        margin-top: 2px;
        font-family: ${m.font.label};
        font-size: 12.5px;
        color: rgba(255,255,255,0.88);
    }
    dl {
        margin: 0;
        padding: 6px 15px;
        > div {
            display: flex;
            justify-content: space-between;
            gap: 14px;
            padding: 10px 0;
            border-bottom: 1px solid ${m.color.line};
            &:last-child { border-bottom: none; }
        }
    }
    dt {
        flex-shrink: 0;
        font-size: 14px;
        color: ${m.color.inkSoft};
    }
    dd {
        margin: 0;
        text-align: right;
        font-size: 14px;
        font-weight: 600;
        color: ${m.color.ink};
    }
    .section { margin: 18px 0 9px; }
    .entradas {
        margin: 10px 0 0;
        padding: 10px 12px;
        border-radius: ${m.radius.md};
        background: ${m.color.surface};
        border: 1px solid ${m.color.line};
        > div {
            display: flex;
            justify-content: space-between;
            gap: 10px;
            font-size: 13px;
            padding: 3px 0;
        }
        dt { color: ${m.color.inkFaint}; }
        dd { margin: 0; font-weight: 600; white-space: nowrap; }
    }
    .total {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin-top: 18px;
        padding: 16px 18px;
        border-radius: ${m.radius.lg};
        background: ${m.color.ink};
        color: ${m.color.surface};
        strong {
            font-family: ${m.font.display};
            font-weight: 600;
            font-size: 28px;
        }
    }
    .total-label {
        display: block;
        font-size: 12.5px;
        font-weight: 600;
        color: rgba(255,255,255,0.7);
    }
    .total-calc {
        display: block;
        margin-top: 3px;
        font-family: ${m.font.label};
        font-size: 11.5px;
        color: rgba(255,255,255,0.55);
    }
    .note {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin: 14px 0 0;
        font-size: 12.5px;
        line-height: 1.4;
        color: ${m.color.inkFaint};
        svg { margin-top: 1px; }
    }
`
